import { type HttpClient, type RouteGenerator } from "silver";
import { debounce } from "shared/functions";

export class AvatarIDService {

	private abortController = new AbortController;
	public delay: number = 1000;

	constructor(
		private httpClient: HttpClient,
		private router: RouteGenerator,
	) {
		this.setAuthUserAvatarID = debounce(this.setAuthUserAvatarID, this.delay);
	}

	public setAuthUserAvatarID(id: number): void {
		this.abortController.abort(); // don't bother completing old sets
		this.abortController = new AbortController();
		const url = this.router.generate("user/avatar", null, { }, "json");
		this.httpClient.post(url, {
			abortController: this.abortController,
			body:            { id }
		}).catch(console.error);
	}
}
